import React from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../store";
import { isDevEnvironment } from "../../utils/envUtils";
import { SmallText } from "../../lib/ui/components/typography/Typography";

export default function PersonaSwitcher() {
  const activePersona = useStore((state) => state.activePersona);
  const setActivePersona = useStore((state) => state.setActivePersona);
  const navigate = useNavigate();

  if (!isDevEnvironment()) return null;

  const isCandidate = activePersona === "candidate";

  const handleSwitch = () => {
    const next = isCandidate ? "employer" : "candidate";
    setActivePersona(next);
    navigate(next === "candidate" ? "/candidate/dashboard" : "/jobs");
  };

  return (
    <div className="fixed bottom-4 left-4 z-50 flex items-center gap-3 bg-gray-900 text-white px-4 py-2.5 rounded-lg shadow-lg">
      <SmallText weight="semibold" className="text-white whitespace-nowrap">
        DEV
      </SmallText>
      <div className="w-px h-4 bg-gray-600" />
      <button
        onClick={handleSwitch}
        className="flex items-center gap-2 px-3 py-1 rounded-md bg-gray-700 hover:bg-gray-600 transition-colors text-small font-medium"
      >
        <span
          className={`inline-block w-2 h-2 rounded-full ${
            isCandidate ? "bg-green-400" : "bg-blue-400"
          }`}
        />
        {isCandidate ? "Candidate" : "Employer"}
      </button>
      <SmallText className="text-gray-400">
        Switch to {isCandidate ? "Employer" : "Candidate"}
      </SmallText>
    </div>
  );
}
